<template>
  <div :class="$style.wrap">
    <div :class="$style.left">
      <slot name="actions" />
    </div>
    <app-pager
      :class="$style.center"
      :has-next-page="hasNextPage"
      :has-previous-page="hasPreviousPage"
      center
      show-always
      @next-page="onNextPage"
      @previous-page="onPreviousPage"
    />
    <div :class="$style.right">
      <el-button round size="medium" icon="el-icon-refresh" @click="onReload" />
    </div>
  </div>
</template>

<script>
import { emptyFn } from "~/util/empty-fn";
import AppPager from "~/components/common/list/AppPager";

export default {
  name: "DataTableFooter",
  components: { AppPager },
  props: {
    reload: {
      type: Function,
      default: emptyFn,
    },
    hasNextPage: {
      type: Boolean,
      default: false,
    },
    hasPreviousPage: {
      type: Boolean,
      default: false,
    },
    table: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onNextPage() {
      this.$emit("next-page");
      this.scrollToTableTop();
    },
    onPreviousPage() {
      this.$emit("previous-page");
      this.scrollToTableTop();
    },
    onReload() {
      const pro = this.reload();
      const chain = pro instanceof Promise ? pro : Promise.resolve(true);
      chain.finally(this.scrollToTableTop);
    },
    scrollToTableTop() {
      const { table } = this;
      if (table) {
        const el = table.$el || table;
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
  },
};
</script>

<style module lang="module.css">
.wrap {
  display: flex;
  align-items: center;
}
.side {
  flex: 1;
}
.left {
  composes: side;
}
.right {
  composes: side;
  text-align: right;
}
.center {
  width: 100px;
}
</style>
